import React, { useMemo } from 'react';
import classNames from 'classnames';
import { MapValue } from 'models/Listing';
import { FieldRenderProps } from 'react-final-form';
import Map from '../Map/Map.component';
import FieldWrapper from 'components/FieldWrapper';
import { FieldWrapperProps } from 'components/FieldWrapper/FieldWrapper.component';

import './MapField.styles.scss';

export type MapFieldProps = FieldRenderProps<MapValue, HTMLElement> &
  FieldWrapperProps & {
    customOnChange?: (value: MapValue, isValid: boolean) => void;
  };

const MapField: React.FC<MapFieldProps> = (props) => {
  const {
    input: { value, onChange },
    meta: { touched, error },
    className,
    label,
    required = true,
    customOnChange,
  } = props;

  const hasError = useMemo(() => touched && error, [error, touched]);
  const classes = classNames(
    'map-field',
    { 'map-field--error': hasError },
    className,
  );

  return (
    <FieldWrapper className={classes} required={required} label={label}>
      <Map
        value={value}
        onChange={(e) => {
          onChange(e);
          customOnChange?.(e, !hasError);
        }}
      />
    </FieldWrapper>
  );
};

export default MapField;
